import {
  ACCOUNT_KEY_IOCS_SET,
  ACCOUNT_KEY_IOCS_REQ,
  ACCOUNT_KEY_IOCS_SUCCESS,
  ACCOUNT_KEY_IOCS_ERROR,
  ACCOUNT_KEY_IOCS_RESET_STATUS,
  MULTIPLE_ACCOUNT_KEY_IOCS_SET,
  MULTIPLE_ACCOUNT_KEY_IOCS_REQ
} from './detections.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import Detection from '@/resources/models/Detection'
import { OrderByEnum } from '@/constants/orderby.constants'
import { iocDetectionsMetaInfo } from '@/column-header/detections/ioc-detections-meta'

const state = {
  accountKeyIocsReqStatus: '',
  accountKeyIocsList: {}
}

const getters = {
  accountKeyIocsReqStatus: state => state.accountKeyIocsReqStatus,
  accountKeyIocsList: state => state.accountKeyIocsList,
  multipleAccountKeyIocsReqStatus: state => state.multipleAccountKeyIocsReqStatus,
  multipleAccountKeyIocsList: state => state.multipleAccountKeyIocsList
}

// Best Practice - updates state
const mutations = {
  [ACCOUNT_KEY_IOCS_SET]: (state, data) => {
    state.accountKeyIocsList = data
  },
  [ACCOUNT_KEY_IOCS_REQ]: state => {
    state.accountKeyIocsReqStatus = 'loading'
  },
  [ACCOUNT_KEY_IOCS_SUCCESS]: (state, data) => {
    state.accountKeyIocsReqStatus = 'saved'
  },
  [ACCOUNT_KEY_IOCS_ERROR]: (state, errMsg) => {
    state.accountKeyIocsReqStatus = 'error'
  },
  [ACCOUNT_KEY_IOCS_RESET_STATUS]: state => {
    state.accountKeyIocsReqStatus = ''
  },
  [MULTIPLE_ACCOUNT_KEY_IOCS_SET]: (state, data) => {
    state.multipleAccountKeyIocsList = data
  },
  [MULTIPLE_ACCOUNT_KEY_IOCS_REQ]: state => {
    state.accountKeyIocsReqStatus = 'loading'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [ACCOUNT_KEY_IOCS_REQ] (context, { integrationType, accountKey } = {}) {
    let accountKeyEncoded, apiUrl
    if (integrationType) {
      accountKeyEncoded = encodeURIComponent(integrationType)
      apiUrl = `/integrations/accounts/integration/detections/${accountKeyEncoded}`
    } else {
      accountKeyEncoded = encodeURIComponent(accountKey)
      apiUrl = `/integrations/accounts/discovery/detections/${accountKeyEncoded}`
    }
    return new Promise((resolve, reject) => {
      context.commit(ACCOUNT_KEY_IOCS_REQ)
      ApiRest()
        .get(apiUrl)
        .then(({ data }) => {
          data = _.chain(data)
            .sort((a, b) => {
              return b.seenTime - a.seenTime // sort by desc
            })
            .map(detection => {
              let detectionRule = {}
              let detectionHost = {}

              if (detection.ruleid === 0) {
                detectionRule = {
                  id: 0,
                  name: detection.iocSummary
                }
              } else if (!_.isEmpty(context.rootState.rules.allRulesList)) {
                detectionRule = _.find(context.rootState.rules.allRulesList, {
                  id: `${detection.ruleid}`
                })
              }

              if (!_.isEmpty(context.rootState.agents.agentList.models)) {
                detectionHost = _.find(context.rootState.agents.agentList.models, {
                  agentId: detection.agentId
                })
              }
              detection.rule = detectionRule
              detection.host = detectionHost
              let ioc = new Detection(undefined, detection)
              ioc.setTrail(detection.attackIdList)
              return ioc
            })
            .value()

          let detections = new IQCollection(
            data,
            { attributes: iocDetectionsMetaInfo.meta.columns },
            { defaultSort: 'seenTime', sortOrder: OrderByEnum.DESC }
          )

          context.commit(ACCOUNT_KEY_IOCS_SET, detections)
          resolve(detections)
        })
        .catch(errMsg => {
          context.commit(ACCOUNT_KEY_IOCS_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [ACCOUNT_KEY_IOCS_SUCCESS] (context) {
    context.commit(ACCOUNT_KEY_IOCS_SUCCESS)
  },
  [ACCOUNT_KEY_IOCS_RESET_STATUS] (context) {
    context.commit(ACCOUNT_KEY_IOCS_RESET_STATUS)
  },
  [MULTIPLE_ACCOUNT_KEY_IOCS_REQ] (context, { accountKeys } = {}) {
    return new Promise((resolve, reject) => {
      context.commit(MULTIPLE_ACCOUNT_KEY_IOCS_REQ)
      ApiRest()
        .post(`/integrations/accounts/discovery/detections`, { keys: accountKeys })
        .then(({ data }) => {
          data = _.chain(data)
            .sort((a, b) => {
              return b.seenTime - a.seenTime // sort by desc
            })
            .map(detection => {
              let detectionRule = {}
              let detectionHost = {}

              if (detection.ruleid === 0) {
                detectionRule = {
                  id: 0,
                  name: detection.iocSummary
                }
              } else if (!_.isEmpty(context.rootState.rules.allRulesList)) {
                detectionRule = _.find(context.rootState.rules.allRulesList, {
                  id: `${detection.ruleid}`
                })
              }

              if (!_.isEmpty(context.rootState.agents.agentList.models)) {
                detectionHost = _.find(context.rootState.agents.agentList.models, {
                  agentId: detection.agentId
                })
              }
              detection.rule = detectionRule
              detection.host = detectionHost
              let ioc = new Detection(undefined, detection)
              ioc.setTrail(detection.attackIdList)
              return ioc
            })
            .value()

          let detections = new IQCollection(
            data,
            { attributes: iocDetectionsMetaInfo.meta.columns },
            { defaultSort: 'seenTime', sortOrder: OrderByEnum.DESC }
          )

          context.commit(MULTIPLE_ACCOUNT_KEY_IOCS_SET, detections)
          resolve(detections)
        })
        .catch(errMsg => {
          context.commit(ACCOUNT_KEY_IOCS_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/detections/accountkey-detections.module.js